import React from "react"
import { useSnackbar } from "notistack"
import { RoboComunidade } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

const CLASSES = [
    { v: "", t: "Qualquer classificação" },
    { v: "dono_restaurante", t: "🍽 Dono de restaurante" },
    { v: "fornecedor", t: "📦 Fornecedor" },
    { v: "gestor_delivery", t: "🛵 Gestor delivery" },
    { v: "gestor_trafego", t: "📈 Gestor de tráfego" },
    { v: "consultor", t: "🎓 Consultor" },
    { v: "concorrente", t: "⚠ Concorrente" },
]

/** Participantes dos grupos (porte da rail 👥). */
export function Participantes() {
    const { enqueueSnackbar } = useSnackbar()
    const [itens, setItens] = React.useState<any[]>([])
    const [busca, setBusca] = React.useState("")
    const [classif, setClassif] = React.useState("")
    const [ordenar, setOrdenar] = React.useState("recentes")
    const [fBusiness, setFBusiness] = React.useState("")
    const [fStatus, setFStatus] = React.useState("")
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            const r = await RoboComunidade.listarParticipantes({
                busca: busca.trim() || undefined,
                classificacao: classif || undefined,
                limite: 300,
            })
            setItens(Array.isArray(r) ? r : r?.items || [])
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [busca, classif, enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    const vista = React.useMemo(() => {
        let v = itens.slice()
        if (fBusiness === "business") v = v.filter(p => p.isBusiness)
        else if (fBusiness === "personal") v = v.filter(p => !p.isBusiness)
        if (fStatus === "ativo") v = v.filter(p => p.ativo !== false)
        else if (fStatus === "inativo") v = v.filter(p => p.ativo === false)
        const nome = (p: any) => (p.nome || p.pushname || p.waId || "").toLowerCase()
        const ts = (p: any) => {
            const d = p.ultimoVistoEm ? Date.parse(p.ultimoVistoEm) : 0
            return isNaN(d) ? 0 : d
        }
        if (ordenar === "nome_asc") v.sort((a, b) => nome(a).localeCompare(nome(b)))
        else if (ordenar === "nome_desc") v.sort((a, b) => nome(b).localeCompare(nome(a)))
        else v.sort((a, b) => ts(b) - ts(a))
        return v
    }, [itens, fBusiness, fStatus, ordenar])

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <h3 style={{ margin: 0 }}>👥 Participantes</h3>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar
                </button>
            </div>
            <div className="form-row" style={{ padding: "0 12px", gap: 6 }}>
                <input
                    type="text"
                    placeholder="🔎 nome, telefone ou classificação"
                    value={busca}
                    onChange={e => setBusca(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && carregar()}
                />
                <select value={classif} onChange={e => setClassif(e.target.value)}>
                    {CLASSES.map(c => (
                        <option key={c.v} value={c.v}>
                            {c.t}
                        </option>
                    ))}
                </select>
                <select value={fBusiness} onChange={e => setFBusiness(e.target.value)} title="Tipo de conta">
                    <option value="">Qualquer conta</option>
                    <option value="business">💼 Só Business</option>
                    <option value="personal">👤 Só Pessoal</option>
                </select>
                <select value={fStatus} onChange={e => setFStatus(e.target.value)} title="Status">
                    <option value="">Qualquer status</option>
                    <option value="ativo">✅ Ativos</option>
                    <option value="inativo">🚪 Saíram</option>
                </select>
                <select value={ordenar} onChange={e => setOrdenar(e.target.value)} title="Ordenar">
                    <option value="recentes">Últimos vistos</option>
                    <option value="nome_asc">Nome (A-Z)</option>
                    <option value="nome_desc">Nome (Z-A)</option>
                </select>
            </div>
            <div className="muted small" style={{ padding: "6px 12px" }}>
                {carregando ? "Carregando…" : vista.length + " participante(s)"}
            </div>
            <div className="participants-table-wrap" style={{ padding: "0 12px 12px", overflowX: "auto" }}>
                <table id="participants-table" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>Telefone</th>
                            <th>Nome</th>
                            <th>Pushname</th>
                            <th>Business</th>
                            <th>Classificação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vista.map(p => (
                            <tr key={p.id}>
                                <td>{p.telefone || p.waId || "—"}</td>
                                <td>{p.nome || "—"}</td>
                                <td>{p.pushname || "—"}</td>
                                <td>{p.isBusiness ? "💼" : "—"}</td>
                                <td>{p.classificacao || "—"}</td>
                            </tr>
                        ))}
                        {!carregando && vista.length === 0 && (
                            <tr>
                                <td colSpan={5}>
                                    <span className="muted small">Nenhum participante.</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default Participantes
